module.exports = __webpack_public_path__ + "images/pages/for_business/sp/case2_ad0372f4936a6d6c0627a5df67c0d7b1.png";